export default __webpack_public_path__ + "static/media/attribute-mapping.4440780a.png";